import React from 'react';
import * as Icons from '../../assets/svg/icons';
import AnimatedBottomSheet from './animatedBottomSheet';

export const RxStatusWarningModal = ({
    showModal,
    setShowModal,
    onConfirm,
    onCancel,
    rxStatusData
}) => {
    return (
        <React.Fragment>
            <AnimatedBottomSheet isOpen={showModal} onClose={() => setShowModal(false)} ariaLabel="Medication Warning">
                        <div className="flex items-center justify-between p-2 px-4 md:p-2 border-b border-dashed rounded-t">
                            <h3 className="text-sm font-bold text-gray-900">
                                ⚠️ Warning
                            </h3>
                            <button type="button"
                                onClick={() => setShowModal(false)}
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                data-modal-hide="bottom-right-modal">
                                <Icons.CloseModelIcon />
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="max-w-md mx-auto p-2 bg-white rounded-md">
                            <form>
                                <div className="mb-2">
                                    <div className="flex items-center justify-center">
                                        <div className="bg-yellow-100 rounded-full p-3">
                                            <svg className="w-8 h-8 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
                                                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
                                            </svg>
                                        </div>
                                    </div>


                                    <div className="text-center mb-1">
                                        <p className="text-gray-700 mb-1">
                                            The following RX(s) have been stopped or transferred:
                                        </p>

                                        <div className="bg-red-50 border border-red-200 rounded-md p-2 flex gap-2 overflow-y-auto">
                                            {rxStatusData?.map((rx, index) => (
                                                <div key={index} className="text-sm w-fit text-red-700  p-1 bg-red-100 rounded border-l-4 border-red-500">
                                                    <div className="flex items-center justify-between">
                                                        <div>
                                                            <strong className="text-red-800">RX #{rx.rxnumber}</strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>

                                        <p className="text-gray-700 font-medium mt-1">
                                            Do you still want to deliver this medication?
                                        </p>
                                    </div>
                                </div>

                                <div className="flex justify-center items-center gap-2">
                                    <button
                                        onClick={onConfirm}
                                        type="button"
                                        className="bg-[#10b981] hover:bg-green-700 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
                                    >
                                        Yes, Deliver Anyway
                                    </button>
                                    <button
                                        onClick={onCancel}
                                        type="button"
                                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
                                    >
                                        No
                                    </button>
                                </div>
                            </form>
                        </div>
            </AnimatedBottomSheet>
        </React.Fragment>
    );
};




// export const FlexiRxStatusWarningModal = ({
//     showModal,
//     setShowModal,
//     onConfirm,
//     onCancel,
//     rxNumbers
// }) => {
//     return (
//         <React.Fragment>
//             <Sheet isOpen={showModal} onClose={() => setShowModal(false)}>
//                 <Sheet.Container>
//                     <Sheet.Content>
//                         <div className="flex items-center justify-between p-2 px-4 md:p-2 border-b border-dashed rounded-t">
//                             <h3 className="text-sm font-bold text-gray-900">
//                                 ⚠️ Warning
//                             </h3>
//                             <button type="button"
//                                 onClick={() => setShowModal(false)}
//                                 className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
//                                 data-modal-hide="bottom-right-modal">
//                                 <Icons.CloseModelIcon />
//                                 <span className="sr-only">Close modal</span>
//                             </button>
//                         </div>
//                         <div className="max-w-md mx-auto p-2 bg-white rounded-md">
//                             <form>
//                                 <div className="mb-2">
//                                     <div className="flex items-center justify-center">
//                                         <div className="bg-yellow-100 rounded-full p-3">
//                                             <svg className="w-8 h-8 text-yellow-600" fill="currentColor" viewBox="0 0 20 20">
//                                                 <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
//                                             </svg>
//                                         </div>
//                                     </div>


//                                     <div className="text-center mb-1">
//                                         <p className="text-gray-700 mb-1">
//                                             The following RX(s) have been marked as Flexi:
//                                         </p>

//                                         <div className="bg-red-50 border border-red-200 rounded-md p-2 flex gap-2 overflow-y-auto">
//                                             {rxNumbers?.map((rx, index) => (
//                                                 <div key={index} className="text-sm w-fit text-red-700  p-1 bg-red-100 rounded border-l-4 border-red-500">
//                                                     <div className="flex items-center justify-between">
//                                                         <div>
//                                                             <strong className="text-red-800">RX #{rx}</strong>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             ))}

//                                         </div>

//                                         <p className="text-gray-700 font-medium mt-1">
//                                             Do you still want to deliver this medication?
//                                         </p>
//                                     </div>
//                                 </div>

//                                 <div className="flex justify-center items-center gap-2">
//                                     <button
//                                         onClick={onConfirm}
//                                         type="button"
//                                         className="bg-[#10b981] hover:bg-green-700 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-green-500 focus:ring-opacity-50"
//                                     >
//                                         Yes, Deliver Anyway
//                                     </button>
//                                     <button
//                                         onClick={onCancel}
//                                         type="button"
//                                         className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
//                                     >
//                                         Cancel
//                                     </button>
//                                 </div>
//                             </form>
//                         </div>
//                     </Sheet.Content>
//                 </Sheet.Container>
//                 <Sheet.Backdrop />
//             </Sheet>
//         </React.Fragment>
//     );
// }; 




export const FlexiRxStatusWarningModal = ({
    showModal,
    setShowModal,
    onConfirm,
    onCancel,
    rxNumbers
}) => {
    const handleReload = () => {
        window.location.reload();
    };


    const message = rxNumbers.length > 1
        ? "The following RXs were updated. Reload to see changes."
        : "The following RX was updated. Reload to see changes.";


    return (
        <React.Fragment>
            <AnimatedBottomSheet isOpen={showModal} onClose={() => setShowModal(false)} ariaLabel="Medication Update Detected">
                        <div className="flex items-center justify-between p-2 px-4 md:p-2 border-b border-dashed rounded-t">
                            <h3 className="text-sm font-bold text-gray-900">
                                ⚠️ Update Detected
                            </h3>
                            <button
                                type="button"
                                onClick={() => setShowModal(false)}
                                className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                            >
                                <Icons.CloseModelIcon />
                                <span className="sr-only">Close modal</span>
                            </button>
                        </div>
                        <div className="max-w-md mx-auto p-2 bg-white rounded-md">
                            <form>
                                <div className="mb-2">
                                    <div className="flex items-center justify-center">
                                        <div className="bg-yellow-100 rounded-full p-3">
                                            <svg
                                                className="w-8 h-8 text-yellow-600"
                                                fill="currentColor"
                                                viewBox="0 0 20 20"
                                            >
                                                <path
                                                    fillRule="evenodd"
                                                    d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                                                    clipRule="evenodd"
                                                />
                                            </svg>
                                        </div>
                                    </div>

                                    <div className="text-center mb-1">
                                        <p className="text-gray-700 mb-1 font-medium">
                                            {message}
                                        </p>

                                        <div className="bg-red-50 border border-red-200 rounded-md p-2 flex gap-2 overflow-y-auto">
                                            {rxNumbers?.map((rx, index) => (
                                                <div
                                                    key={index}
                                                    className="text-sm w-fit text-red-700 p-1 bg-red-100 rounded border-l-4 border-red-500"
                                                >
                                                    <div className="flex items-center justify-between">
                                                        <div>
                                                            <strong className="text-red-800">
                                                                RX #{rx}
                                                            </strong>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>

                                <div className="flex justify-center items-center gap-2">
                                    <button
                                        onClick={handleReload}
                                        type="button"
                                        className="bg-blue-700 hover:bg-blue-700 text-white font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
                                    >
                                        Reload
                                    </button>
                                    {/* <button
                                        onClick={onCancel}
                                        type="button"
                                        className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold px-4 py-2 rounded focus:outline-none focus:ring-2 focus:ring-gray-300 focus:ring-opacity-50"
                                    >
                                        Cancel
                                    </button> */}
                                </div>
                            </form>
                        </div>
            </AnimatedBottomSheet>
        </React.Fragment>
    );
};
